<template>
    <v-app class="login-page">
        <v-main class="login-wrapper">

            <!-- Left Pane (Desktop Only) -->
            <div class="login-left">
                <img src="@/assets/image.png" class="bg-image" />
                <img src="@/assets/logo_white.png" class="logo" />
            </div>

            <!-- Right Pane -->
            <div class="login-right">
                <div class="login-form">

                    <!-- Header -->
                    <div class="mb-8">
                        <img src="../assets/logo.png" class="logo-img" alt="Crowdital Logo" />
                        <h3 class="text-2xl font-semibold text-gray-900 mt-8">
                            Nice to meet you,
                        </h3>
                        <p class="text-gray-400 text-xs mt-2">
                            Sign up for an account below
                        </p>
                    </div>

                    <!-- Form -->
                    <form @submit.prevent="handleSignup" class="w-full space-y-6">

                        <!-- Firstname -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Firstname</label>
                            <input v-model="firstname" type="text" required placeholder="John" class="modern-input" />
                        </div>

                        <!-- Lastname -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Lastname</label>
                            <input v-model="lastname" type="text" required placeholder="Doe" class="modern-input" />
                        </div>

                        <!-- Phone -->
                        <!-- <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Phone</label>
                            <input v-model="phone" type="text" required placeholder="080XXXXXXX"
                                class="modern-input" />
                        </div> -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700">
                                Phone
                            </label>

                            <div class="phone-input-wrapper">

                                <!-- Country -->
                                <div class="country-selector">
                                    <select v-model="selectedCountry">
                                        <option v-for="country in countries" :key="country.iso2" :value="country">
                                            {{ country.emoji }} +{{ country.phonecode }}
                                        </option>
                                    </select>
                                </div>
                                <!-- Phone Number -->
                                <input v-model="phone" type="tel" inputmode="numeric" autocomplete="tel"
                                    placeholder="8012345678" class="phone-number-input" maxlength="15"
                                    @input="handlePhoneInput" />

                            </div>

                            <small v-if="phoneError" class="text-red-500">
                                {{ phoneError }}
                            </small>
                        </div>

                        <!-- Email -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Email</label>
                            <input v-model="email" type="email" required placeholder="email@example.com"
                                class="modern-input" />
                        </div>

                        <!-- Password -->
                        <div class="flex flex-col gap-2 spacing text-left w-full mb-4 relative">
                            <label class="text-sm font-medium text-gray-700">Password</label>
                            <input v-model="password" :type="showPassword ? 'text' : 'password'" required
                                placeholder="••••••••" class="modern-input pr-10 w-full" />

                            <!-- Eye icon -->
                            <button type="button" @click="togglePassword"
                                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-black">
                                <svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>

                                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" class="w-5 h-5">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a10.05 10.05 0 012.171-3.386m1.348-1.348A10.05 10.05 0 0112 5c4.477 0 8.268 2.943 9.542 7a10.05 10.05 0 01-1.639 3.15M3 3l18 18" />
                                </svg>
                            </button>
                        </div>

                        <!-- Phone -->
                        <div class="flex flex-col gap-2 spacing text-left">
                            <label class="text-sm font-medium text-gray-700 text-left">Referral Code (Optional)</label>
                            <input v-model="referral_code" type="text" required placeholder="Enter referral code"
                                readonly class="modern-input" />
                        </div>

                        <!-- Terms -->
                        <div class="w-full flex justify-between mt-4 text-left spacing">
                            <Checkbox v-model="agreed" inputId="terms" binary />
                            <label for="terms"> I agree with Terms of use</label>
                        </div>
                        <div v-if="submitted && !agreed" class="text-red text-caption mt-1">
                            You must accept the terms to continue
                        </div>
                        <!-- Submit -->
                        <button type="submit" :disabled="loading || !agreed" class="login-button mb-4 mt-6">
                            <span v-if="!loading">Create Account <v-icon start>mdi-account-plus-outline</v-icon></span>
                            <span v-else>Processing… <v-icon start class="spin">mdi-loading</v-icon></span>
                        </button>
                        <p>Already have an account?
                            <button type="button" @click="signin"
                                class="text-sm font-medium text-green hover:text-black transition-colors">
                                Login
                            </button>
                        </p>
                    </form>
                    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
                        snackbar.message }}
                        <template #actions>
                            <v-btn variant="text" @click="snackbar.show = false">
                                Close
                            </v-btn>
                        </template>
                    </v-snackbar>

                </div>
            </div>

        </v-main>
    </v-app>
</template>

<script setup>
import { ref, onMounted, computed } from "vue"
import { useRouter, useRoute } from "vue-router"
import { reg } from "@/api/auth"
import { getAllErrors } from "@/util"
import { useUserStore } from "@/store/user"
import { fetchCountries } from "@/api/dashboard"

const router = useRouter()
const route = useRoute()
const user = useUserStore()

const email = ref("")
const password = ref("")
const firstname = ref("")
const lastname = ref('')
const phone = ref("")
const error = ref("")
const loading = ref(false)
const agreed = ref(false)
const submitted = ref(false)
const referral_code = ref("")
const phoneError = ref("")

//Snack bar
const snackbar = ref({
    show: false,
    message: "",
    color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
    snackbar.value.message = message
    snackbar.value.color = color
    snackbar.value.show = true
}

/**============= Show or hide password   ================*/
const showPassword = ref(false)

const togglePassword = () => {
    showPassword.value = !showPassword.value
}

onMounted(async () => {
    const ref = route.query.ref

    if (ref) {
        referral_code.value = ref
    }
    await loadCountries()

    console.log("Countries after loading:", countries.value)
    console.log("Selected country:", selectedCountry.value)
})

const handlePhoneInput = (event) => {
    let value = event.target.value

    // Only numbers
    value = value.replace(/\D/g, "")

    // Remove 0 from the beginning
    value = value.replace(/^0+/, "")

    phone.value = value

    phoneError.value = ""
}

const fullPhoneNumber = computed(() => {
    return `${selectedCountry.value.phonecode}${phone.value}`
    //return `${selectedCountry.value.dialCode.replace("+", "")}${phone.value}`
})

const validatePhone = () => {
    if (!phone.value) {
        phoneError.value = "Phone number is required"
        return false
    }

    if (phone.value.startsWith("0")) {
        phoneError.value = "Phone number cannot start with 0"
        return false
    }

    if (phone.value.length < 7) {
        phoneError.value = "Enter a valid phone number"
        return false
    }

    phoneError.value = ""

    return true
}


const countries = ref([])

const selectedCountry = ref(null)

const loadCountries = async () => {
    try {
        const res = await fetchCountries()

        //console.log("Countries API response:", res.data)

        countries.value = res?.data?.data || []

        // Select Nigeria by default
        selectedCountry.value =
            countries.value.find(country =>
                String(country.name || "")
                    .trim()
                    .toLowerCase()
                    .includes("nigeria")
            ) || null

        console.log("Selected country:", selectedCountry.value)

    } catch (e) {
        console.error("Failed to load countries:", e)
        countries.value = []
        selectedCountry.value = null
    }
}

const handleSignup = async () => {

    submitted.value = true

    // stop if not agreed
    if (!agreed.value) return

    error.value = ""
    loading.value = true
    try {
        const payload = {
            firstname: firstname.value.trim(),
            lastname: lastname.value.trim(),
            email: email.value.trim(),
            phone: fullPhoneNumber.value.trim(),
            //phone: phone.value.trim(),
            password: password.value,
            policy_agreement: true,
            is_pep: false,
        }

        if (referral_code.value?.trim()) {
            payload.referral_code = referral_code.value.trim()
        }

        if (!validatePhone()) {
            return
        }
        
        await reg(payload)

        user.setEmail(email.value.trim())

        // SUCCESS MESSAGE
        showSnackbar("Account created successfully!", "success")

        setTimeout(() => {
            router.push({
                name: "Verify",
                query: {
                    email: email.value.trim()
                }
            })
        }, 1000)
        //localStorage.setItem("token", res.data.data.token)
        //router.push("/add-username")
    } catch (e) {
        const msg = getAllErrors(e)
        //console.log(e.response?.data)
        showSnackbar(
            msg || "Signup failed",
            "error"
        )
    } finally {
        loading.value = false
    }
}

const signin = () => {
    router.push("/login")
}

</script>

<style scoped>
/* Layout */
.login-wrapper {
    display: flex;
    min-height: 100vh;
}

.login-left {
    flex: 1;
    position: relative;
    overflow: hidden;
}

.bg-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.logo-img {
    width: 20em;
}

.logo {
    position: absolute;
    bottom: 24px;
    left: 24px;
    width: 130px;
}

.login-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f9fafb;
    padding: 24px;
}

.login-form {
    width: 100%;
    max-width: 420px;
}

/* Inputs */
.modern-input {
    width: 100%;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: transparent;
    transition: all 0.2s ease;
}

.modern-input:focus {
    outline: none;
    border-color: #000;
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

/* Button */
.login-button {
    width: 100%;
    height: 46px;
    background: #000;
    color: #fff;
    border-radius: 10px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.login-button:hover {
    background: #292828;
}

.login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spacing {
    margin-bottom: 1em;
}

.m-space {
    margin-left: 9.5rem !important;
}

.modern-input.pr-10 {
    padding-right: 2.5rem;
    /* enough space for eye button */
}

.relative {
    position: relative;
}

/* Button positioned over the input */
.absolute {
    position: absolute;
    cursor: pointer;
}

.spin {
    animation: spin 1s linear infinite;
}

.phone-input-wrapper {
    display: flex;
    width: 100%;
    height: 48px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
    transition: all 0.2s ease;
}

.phone-input-wrapper:focus-within {
    border-color: #111827;
    box-shadow: 0 0 0 2px rgba(17, 24, 39, 0.08);
}

/* Country selector */
.country-selector {
    display: flex;
    align-items: center;
    padding: 0 10px;
    border-right: 1px solid #e5e7eb;
    background: #f9fafb;
    min-width: 105px;
}

.country-selector select {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #374151;
    cursor: pointer;
    appearance: auto;
}

/* Phone input */
.phone-number-input {
    flex: 1;
    min-width: 0;
    border: none;
    outline: none;
    padding: 0 14px;
    font-size: 15px;
    color: #111827;
    background: transparent;
}

.phone-number-input::placeholder {
    color: #9ca3af;
}

/* Error */
.text-red-500 {
    color: #ef4444;
    font-size: 12px;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* Mobile */
@media (max-width: 767px) {
    .login-wrapper {
        flex-direction: column;
    }

    .login-left {
        display: none;
    }

    .m-space {
        margin-left: 7rem !important;
    }

    .country-selector {
        min-width: 95px;
        padding: 0 8px;
    }

    .country-selector select {
        font-size: 13px;
    }

    .phone-number-input {
        font-size: 14px;
        padding: 0 10px;
    }
}
</style>
